const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBricks(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M333.477,272.749a94.62,94.62,0,0,1,32.77,5.788,32.128,32.128,0,0,0,24.212-1.063,55.687,55.687,0,0,1,23.109-4.743,58.592,58.592,0,0,1,24.726,4.6,31.666,31.666,0,0,0,24.452.6c11.327-6.123,25.632.816,25.684,14.231V326.1H333.477Z",
    style: {
      fill: "#778591"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,185.813a65.772,65.772,0,0,1,29.243,4.647,28.684,28.684,0,0,0,21.856-.471,55.516,55.516,0,0,1,7.56-2.62,15.045,15.045,0,0,1,18.818,14.611v39.65H256Z",
    style: {
      fill: "#778591"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.57,
    y: 397.15,
    width: 154.953,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.524,
    y: 397.15,
    width: 154.953,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.57,
    y: 214.59,
    width: 154.953,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.477,305.87H178.524V214.59H313.707a19.77,19.77,0,0,1,19.77,19.77Z",
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.477,
    y: 397.15,
    width: 154.953,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.57,
    y: 305.87,
    width: 77.477,
    height: 91.28,
    style: {
      fill: "#d85656"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.047,
    y: 305.87,
    width: 154.953,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23.57,
    y: 123.31,
    width: 77.477,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,214.59H101.047V123.31H235.934A20.066,20.066,0,0,1,256,143.377Z",
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.477,
    y: 23.57,
    width: 154.953,
    height: 91.28,
    rx: 19.003,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 305.87,
    width: 154.953,
    height: 91.28,
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.43,397.15H410.953V305.87h57.889a19.588,19.588,0,0,1,19.588,19.588Z",
    style: {
      fill: "#ff7b69"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.9,273.974c-7.2-5.35-16.421-5.15-24.307-1.45A26.012,26.012,0,0,1,440.632,272a64.669,64.669,0,0,0-27.234-5.085,61.422,61.422,0,0,0-25.337,5.26,26.2,26.2,0,0,1-19.829.895,102.433,102.433,0,0,0-9.814-3.006c-7.445-1.7-10.276,9.208-2.849,11.287a90.253,90.253,0,0,1,8.692,2.662,37.8,37.8,0,0,0,28.595-1.231,56.111,56.111,0,0,1,43.1-.123c10.6,4.81,22.3,3.9,32.517-.64,6.652-2.5,14.359,3.044,14.138,10.146v10.79a22.567,22.567,0,0,0-11.075-2.9H339.3c.042-7.327-.03-62.964,0-68.564V201.979a20.827,20.827,0,0,0-8.209-16.636c-17.318-12.452-26.759,6.542-43.705-.3-5.221-1.689-14.076-6.624-16.486,1.221a5.818,5.818,0,0,0,4.241,7.053,63.365,63.365,0,0,1,7.965,2.551,34.739,34.739,0,0,0,26.3-.536,49.69,49.69,0,0,1,6.765-2.344c5.613-1.667,11.664,3.171,11.493,8.988v9.692a22.558,22.558,0,0,0-11.076-2.9H261.82V140.206a22.741,22.741,0,0,0-22.715-22.716c-49.248.024-167.526-.017-215.535,0a5.82,5.82,0,0,0-5.82,5.82v91.28c.044,81.315-.032,192.531,0,273.84a5.82,5.82,0,0,0,5.82,5.82c77.271-.077,232.663.056,309.908,0H488.43a5.82,5.82,0,0,0,5.82-5.82c-.377-41.894.272-124.215,0-165.664V292.161A22.116,22.116,0,0,0,484.9,273.974ZM106.867,129.13H239.105a11.089,11.089,0,0,1,11.075,11.076V208.77H106.867ZM250.18,311.69v79.639H106.867V311.69ZM29.39,129.13H95.227v79.64H29.39Zm0,91.281H172.7V300.05H29.39Zm298.267,262.2H184.344V426.558a5.821,5.821,0,0,0-11.641,0V482.61H29.39V402.97H72.9a5.821,5.821,0,0,0,0-11.641H29.39V311.69H95.227v85.46a5.82,5.82,0,0,0,5.82,5.82c67.266,0,159.4,0,226.61,0ZM261.82,391.329V305.87a5.82,5.82,0,0,0-5.82-5.82H184.344V220.411c32.9.016,99.6-.012,132.237,0a11.088,11.088,0,0,1,11.076,11.075c-.038,5.275.027,61.682,0,68.564H284.9a5.82,5.82,0,0,0,0,11.64c28.375.006,91.38,0,120.229,0v79.639ZM482.61,482.61H339.3V402.97H482.61Zm0-156.514v65.233H416.774V311.69h54.761a11.089,11.089,0,0,1,11.075,11.076Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.549,154.288c6.49,4.1,12.734-5.265,6.46-9.676C223.529,140.5,217.278,149.873,223.549,154.288Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.549,178.253c6.489,4.1,12.736-5.279,6.46-9.677C223.522,164.468,217.281,173.834,223.549,178.253Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.657,253.712c-2.367-5.835-11.223-4.05-11.189,2.226C47.073,265.171,60.659,262.462,57.657,253.712Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.288,274.068c-7.675.2-7.668,11.461,0,11.641C59.959,285.513,59.96,274.276,52.288,274.068Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.93,359.452c-5.853-3.8-12.214,3.956-7.348,8.948C230.768,374.107,238.729,364.414,231.93,359.452Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.47,345.163c5.832,3.8,12.208-3.98,7.333-8.949C226.569,330.513,218.639,340.179,225.47,345.163Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.4,332.576c-6.518-4.072-12.724,5.26-6.461,9.691C465.443,346.333,471.655,337.019,465.4,332.576Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.149,459.3c-5.8-3.826-12.209,4-7.348,8.949C366.053,473.936,373.965,464.276,367.149,459.3Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.839,345.163c5.849,3.794,12.208-3.961,7.348-8.949C202.947,330.514,195.037,340.161,201.839,345.163Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.292,438.505c-2.37-5.81-11.21-4.062-11.189,2.226C42.705,449.975,56.3,447.261,53.292,438.505Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.153,459.851c-5.78-3.825-12.231,4.027-7.348,8.948C50.04,474.5,57.96,464.846,51.153,459.851Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.4,458.978c-6.807,1.459-5.833,11.44,1.136,11.524C79.97,470.17,78.725,457.686,70.4,458.978Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.789,69.589c-4.114-8.3-15.6-.622-9.5,6.344C464.743,80.374,472.186,75.409,469.789,69.589Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.789,45.623c-3.144-7-13.517-2.7-10.752,4.468C462.168,57.107,472.528,52.79,469.789,45.623Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.02,43.019c-6.486-4.109-12.733,5.269-6.46,9.677C444.048,56.8,450.291,47.433,444.02,43.019Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.535,17.75H350.372a22.741,22.741,0,0,0-22.715,22.715V97.954a22.741,22.741,0,0,0,22.715,22.716H471.535A22.741,22.741,0,0,0,494.25,97.954V40.465A22.741,22.741,0,0,0,471.535,17.75Zm11.075,80.2a11.088,11.088,0,0,1-11.075,11.075H350.372A11.088,11.088,0,0,1,339.3,97.954V40.465A11.089,11.089,0,0,1,350.372,29.39H471.535A11.089,11.089,0,0,1,482.61,40.465Z",
    style: {
      fill: "#333"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBricks);
export default __webpack_public_path__ + "static/media/Bricks.86604b3a0dafa55502e092d7044a9092.svg";
export { ForwardRef as ReactComponent };